import { MsalAuthProvider, LoginType } from "react-aad-msal";
import { refreshPermissions } from "./container/action";

const azureAd = {
  instance: "https://login.microsoftonline.com",
  domain: "grundfos.onmicrosoft.com",
  clientId: "ee3891ef-0b73-43fd-87b5-e453a2b41228",
  tenantId: "dabd5d90-87c2-44c9-93cd-783e03236e40",
  resourceId: "118d1901-5a81-4e31-9292-39b640efdb93",
};

const config = {
  auth: {
    authority: `${azureAd.instance}/${azureAd.tenantId}`,
    clientId: azureAd.clientId,
    redirectUri: window.location.origin,
  },
  cache: {
    cacheLocation: "localStorage",
    storeAuthStateInCookie: true,
  },
};

const authenticationParameters = {
  scopes: [`${azureAd.resourceId}/user_impersonation`],
};

export const authProvider = new MsalAuthProvider(
  config,
  authenticationParameters,
  LoginType.Redirect
);

export async function adalApiFetch(fetch, url, options, dispatch) {
  const token = await authProvider.getAccessToken();
  const o = options || {};
  if (!o.headers) {
    o.headers = {};
  }

  o.headers.Authorization = `Bearer ${token.accessToken}`;
  return fetch(url, o).then(async (response) => {
    if (response && response.status === 403) {
      refreshPermissions(token, dispatch);
    }
    return response;
  });
}
